import { LOCALSTORAGE } from "@/constants/localstorage";
import { CommonApiResponseType } from "@/types/api";
import { commonErrorHandler } from "@/shared/utils/error/common.error.handler";
import storage from "@/shared/utils/storage/storage";
import axios from "axios";
import { env } from "@/config/env";
import { User } from "@/core/types/auth";

export interface LoginResponse {
    accessToken: string;
    refreshToken: string;
    userId: string;
    roleId: string;
    user: User
}

const axiosInstance = axios.create({
    baseURL: env.baseUrl,
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${storage.get(localStorage, LOCALSTORAGE.accessToken) || storage.get(sessionStorage, LOCALSTORAGE.accessToken)}`
    },
});

export function authService() {
    return {
        login: async (username: string, password: string, appType: string) => {
           
            try {
                const response = await axiosInstance.post<CommonApiResponseType<LoginResponse>>("/auth/login/", {
                    username,
                    password,
                    appType,
                });
                return response.data.data;
            } catch (error) {
                commonErrorHandler(error);
                throw error;
            }
        },
        logout: async () => {
            try {
                await axiosInstance.get('/auth/logout/');
            } catch (error) {
                commonErrorHandler(error);
                throw error;
            }
        },
        fetchUserDetails: async () => {
            try {
                const response = await axiosInstance.get('/auth/me/');
                return response.data;
            } catch (error) {
                commonErrorHandler(error);
                throw error;
            }
        },
        updateProfile: async (formData: FormData) => {
            try {
                const response = await axiosInstance.post<CommonApiResponseType<{ user: User }>>(
                    "/auth/profile/update/",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                return response.data.data;
            } catch (error) {
                commonErrorHandler(error);
                throw error;
            }
        }
    };
}
